import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import sweetalert2 from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { InspectionService } from '../../../shared/services/inspection.service';
import { RelatedInspectionsModalComponent } from './related-inspections-modal/related-inspections-modal.component';
import { HistoricalInspectionApi } from '../../../shared/sdk';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { GoogleMap } from '@angular/google-maps';
import { SmartAnalyzerService } from '../../../shared/services/smart-analyzer-service';
import { MatDialog } from '@angular/material/dialog';
import { CustomTitleService } from '../../../shared/services/custom-title.service';
import { ChartType, ChartOptions } from 'chart.js';
const DEFAULT_ZOOM = 17;

@Component({
  selector: 'app-inspection-detail',
  templateUrl: './inspection-detail.component.html',
  styleUrls: ['./inspection-detail.component.scss'],
})
export class InspectionDetailComponent implements OnInit {

  inspection: any;
  vehicleType;
  bounds: any = false;
  pictures = [];
  inspectionId: string;
  browserSupportsExifRotation;
  relatedInspections;

  disableRetry = false;

  isAdmin;
  apiLoaded: Observable<boolean>;

  mapOptions: google.maps.MapOptions = {
  };

  markerOptions: google.maps.MarkerOptions = { draggable: false };

  @ViewChild('googleMapRef')
    googleMaps: GoogleMap;
  zoom = DEFAULT_ZOOM - 1; // Hack to map zoom works fine

  public radarChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'right',
      align: 'center' as 'center' | 'end' | 'start',
      labels: {
        usePointStyle: true,
        boxWidth: 10,
        padding: 20,
      },
    },
    scale: {
      ticks: {
        maxTicksLimit: 3,
      },
    },
  };
  public radarChartLabels: string[] = [
    'Encuadre', 'Iluminación', 'Vehículo detectado', 'Calidad',
    'Fotografía real',
  ];

  public radarChartData: any = [];
  colors = [
    'rgb(154, 142, 241,0.2)', 'rgb(140, 37, 129,0.2)',
    'rgb(121, 212, 116,0.2)', 'rgb(224, 170, 64,0.2)',
    'rgb(200, 70, 41,0.2)', 'rgb(84, 153, 70,0.2)',
    'rgb(100, 100, 255,0.2)', 'rgb(255, 100, 100,0.2)',
    'rgb(100, 255, 100,0.2)', 'rgb(255, 255, 100,0.2)',
    'rgb(100, 255, 255,0.2)',
  ];

  borderColors = [
    'rgb(154, 142, 241)', 'rgb(140, 37, 129)',
    'rgb(121, 212, 116)', 'rgb(224, 170, 64)',
    'rgb(200, 70, 41)', 'rgb(84, 153, 70)',
    'rgb(100, 100, 255)', 'rgb(255, 100, 100)',
    'rgb(100, 255, 100)', 'rgb(255, 255, 100)',
    'rgb(100, 255, 255)',
  ];

  public radarChartType: ChartType = 'radar';
  chartColors: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };

  // Diccionario de condiciones climáticas en español
  private weatherConditionTranslations = {
    // Códigos y traducciones
    1000: { day: 'Soleado', night: 'Despejado' },
    1003: { day: 'Parcialmente nublado', night: 'Parcialmente nublado' },
    1006: { day: 'Nublado', night: 'Nublado' },
    1009: { day: 'Cubierto', night: 'Cubierto' },
    1030: { day: 'Bruma', night: 'Bruma' },
    1063: { day: 'Posibilidad de lluvia dispersa', night: 'Posibilidad de lluvia dispersa' },
    1066: { day: 'Posibilidad de nieve dispersa', night: 'Posibilidad de nieve dispersa' },
    1069: { day: 'Posibilidad de aguanieve dispersa', night: 'Posibilidad de aguanieve dispersa' },
    1072: { day: 'Posibilidad de llovizna helada dispersa', night: 'Posibilidad de llovizna helada dispersa' },
    1087: { day: 'Posibilidad de tormentas eléctricas', night: 'Posibilidad de tormentas eléctricas' },
    1114: { day: 'Ventisca de nieve', night: 'Ventisca de nieve' },
    1117: { day: 'Tormenta de nieve', night: 'Tormenta de nieve' },
    1135: { day: 'Niebla', night: 'Niebla' },
    1147: { day: 'Niebla helada', night: 'Niebla helada' },
    1150: { day: 'Llovizna ligera dispersa', night: 'Llovizna ligera dispersa' },
    1153: { day: 'Llovizna ligera', night: 'Llovizna ligera' },
    1168: { day: 'Llovizna helada', night: 'Llovizna helada' },
    1171: { day: 'Llovizna helada intensa', night: 'Llovizna helada intensa' },
    1180: { day: 'Lluvia ligera dispersa', night: 'Lluvia ligera dispersa' },
    1183: { day: 'Lluvia ligera', night: 'Lluvia ligera' },
    1186: { day: 'Lluvia moderada intermitente', night: 'Lluvia moderada intermitente' },
    1189: { day: 'Lluvia moderada', night: 'Lluvia moderada' },
    1192: { day: 'Lluvia intensa intermitente', night: 'Lluvia intensa intermitente' },
    1195: { day: 'Lluvia intensa', night: 'Lluvia intensa' },
    1198: { day: 'Lluvia helada ligera', night: 'Lluvia helada ligera' },
    1201: { day: 'Lluvia helada moderada o intensa', night: 'Lluvia helada moderada o intensa' },
    1204: { day: 'Aguanieve ligera', night: 'Aguanieve ligera' },
    1207: { day: 'Aguanieve moderada o intensa', night: 'Aguanieve moderada o intensa' },
    1210: { day: 'Nieve ligera dispersa', night: 'Nieve ligera dispersa' },
    1213: { day: 'Nieve ligera', night: 'Nieve ligera' },
    1216: { day: 'Nieve moderada dispersa', night: 'Nieve moderada dispersa' },
    1219: { day: 'Nieve moderada', night: 'Nieve moderada' },
    1222: { day: 'Nieve intensa dispersa', night: 'Nieve intensa dispersa' },
    1225: { day: 'Nieve intensa', night: 'Nieve intensa' },
    1237: { day: 'Granizo', night: 'Granizo' },
    1240: { day: 'Chubascos ligeros de lluvia', night: 'Chubascos ligeros de lluvia' },
    1243: { day: 'Chubascos moderados o intensos de lluvia', night: 'Chubascos moderados o intensos de lluvia' },
    1246: { day: 'Chubascos torrenciales', night: 'Chubascos torrenciales' },
    1249: { day: 'Chubascos ligeros de aguanieve', night: 'Chubascos ligeros de aguanieve' },
    1252: { day: 'Chubascos moderados o intensos de aguanieve', night: 'Chubascos moderados o intensos de aguanieve' },
    1255: { day: 'Chubascos ligeros de nieve', night: 'Chubascos ligeros de nieve' },
    1258: { day: 'Chubascos moderados o intensos de nieve', night: 'Chubascos moderados o intensos de nieve' },
    1261: { day: 'Chubascos ligeros de granizo', night: 'Chubascos ligeros de granizo' },
    1264: { day: 'Chubascos moderados o intensos de granizo', night: 'Chubascos moderados o intensos de granizo' },
    1273: { day: 'Lluvia ligera dispersa con truenos', night: 'Lluvia ligera dispersa con truenos' },
    1276: { day: 'Lluvia moderada o intensa con truenos', night: 'Lluvia moderada o intensa con truenos' },
    1279: { day: 'Nieve ligera dispersa con truenos', night: 'Nieve ligera dispersa con truenos' },
    1282: { day: 'Nieve moderada o intensa con truenos', night: 'Nieve moderada o intensa con truenos' },
  };

  // Textos comunes en inglés que pueden venir directamente
  private weatherTextTranslations = {
    'Sunny': 'Soleado',
    'Clear': 'Despejado',
    'Partly cloudy': 'Parcialmente nublado',
    'Cloudy': 'Nublado',
    'Overcast': 'Cubierto',
    'Mist': 'Bruma',
    'Patchy rain possible': 'Posibilidad de lluvia dispersa',
    'Patchy snow possible': 'Posibilidad de nieve dispersa',
    'Patchy sleet possible': 'Posibilidad de aguanieve dispersa',
    'Patchy freezing drizzle possible': 'Posibilidad de llovizna helada dispersa',
    'Thundery outbreaks possible': 'Posibilidad de tormentas eléctricas',
    'Blowing snow': 'Ventisca de nieve',
    'Blizzard': 'Tormenta de nieve',
    'Fog': 'Niebla',
    'Freezing fog': 'Niebla helada',
  };

  /**
   * Traduce la condición climática al español
   * @param condition La condición climática a traducir (código o texto)
   * @param isDay Si es de día o de noche (para algunos códigos)
   * @returns La condición climática traducida al español
   */
  getWeatherConditionInSpanish(condition: any, isDay: boolean = true): string {
    if (!condition) return 'No disponible';

    // Si es un código numérico
    if (typeof condition === 'number' || !isNaN(Number(condition))) {
      const code = Number(condition);
      const timeOfDay = isDay ? 'day' : 'night';

      if (this.weatherConditionTranslations[code]) {
        return this.weatherConditionTranslations[code][timeOfDay];
      }
    }

    // Si es un texto en inglés
    if (typeof condition === 'string' && this.weatherTextTranslations[condition]) {
      return this.weatherTextTranslations[condition];
    }

    // Si no se encuentra traducción, devolver el texto original
    return condition.toString();
  }

  /**
   * Traduce los nombres de las imágenes a un formato más legible en español
   * @param pictureName Nombre de la imagen en el sistema
   * @returns Nombre traducido al español
   */
  translatePictureName(pictureName: string): string {
    const translations = {
      'left': 'izquierda',
      'right': 'derecha',
      'frontLeft': 'delantera izquierda',
      'frontRight': 'delantera derecha',
      'rearLeft': 'trasera izquierda',
      'rearRight': 'trasera derecha',
      'front': 'delantera',
      'rear': 'trasera',
      'windshield': 'parabrisas',
      'windshieldInside': 'interior parabrisas',
      'wheel': 'rueda',
    };

    return translations[pictureName] || pictureName;
  }


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    public dialog: MatDialog,
    private inspectionService: InspectionService,
    private historicalInspectionApi: HistoricalInspectionApi,
    private toastr: ToastrService,
    public smartAnalyzerService: SmartAnalyzerService,
    private customTitleService: CustomTitleService,
  ) {
    this.inspectionId = this.route.snapshot.paramMap.get('id');
  }
  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.isAdmin =
      !!user.roles.filter(role => role.name === 'admin' || role.name === 'superadmin').length;
    this.route.params.subscribe(
      (params) => {
        const id = params['id'];
        this.inspectionId = id;
        this.getInspection();
      },
    );



  }
  showChart;
  getInspection() {
    this.inspectionService.getInspection(this.inspectionId).subscribe(
      (inspection) => {
        this.inspection = inspection;
        
        // Set the title with breadcrumbs
        const titleIdentifier = inspection.vehicleType !== 'bike' 
          ? inspection.licencePlate 
          : inspection.numeroDoc;
          
        this.customTitleService.setTitleWithBreadcrumbs({
          title: `Detalle de Inspección - ${titleIdentifier}`,
          breadcrumbs: [
            {
              text: 'Inspección',
              route: ['/inspectionsList'],
            },
            {
              text: titleIdentifier,
            },
          ],
        });
        
        this.createRadarChart();
        this.loadMap();
        // Only rotate images if chrome version is older than 81
        this.inspectionService.getRelatedIspections(inspection).subscribe((relatedInspections) => {
          this.relatedInspections = relatedInspections;
        });
      },
      () => {
        sweetalert2.fire({
          title: 'Ups! Algo salio mal',
          text: 'Ocurrió un error al acceder a los datos.',
          type: 'error',
          confirmButtonText: 'Salir',
          buttonsStyling: false,
        });
      },
    );
  }
  createRadarChart() {
    this.radarChartData = this.inspection.pictures.map((picture, index) => {
      const colorIndex = index % this.colors.length;
      if (picture.alreadyAnalyzed && picture.analyzeResponse) {
        return {
          data: [
            1 - picture.analyzeResponse?.badFraming,
            1 - picture.analyzeResponse?.badLighting,
            picture.analyzeResponse?.containsACar,
            picture.analyzeResponse?.goodQuality,
            1 - picture.analyzeResponse?.pictureFromScreen,
          ],
          label: `${picture.description}`,
          backgroundColor: this.colors[colorIndex],
          borderColor: this.borderColors[colorIndex],
          borderWidth: 1,
          pointBackgroundColor: this.borderColors[colorIndex],
          pointBorderColor: 'white',
          pointBorderWidth: 2,
          pointRadius: 5,
          pointHoverRadius: 7,
          pointStyle: 'circle',
        };
      }

    }).filter(dataSet => dataSet !== undefined);
    this.showChart = true;
  }
  loadMap() {
    this.bounds = new window['google'].maps.LatLngBounds();
    for (const mm of this.inspection.pictures) {
      this.bounds.extend(
        new window['google'].maps
          .LatLng(mm.location.coordinates[1], mm.location.coordinates[0]));
    }
    setTimeout(() => {
      this.googleMaps.fitBounds(this.bounds, 0);
      const idleSubscription = this.googleMaps.idle.subscribe(() => {
        if (this.googleMaps.getZoom() > DEFAULT_ZOOM) {
          this.zoom = DEFAULT_ZOOM;
        }
        idleSubscription.unsubscribe();
      });
    }, 100);
  }
  searchDamageGlass() {
    if (this.inspection.inspectionForm && this.inspection.inspectionForm.glasses) {
      return this.inspection.inspectionForm.glasses.find(x => x.damaged > 0);
    }
    return false;
  }
  openModalRelated() {
    const options = {
      panelClass: 'modal-dialog',
      data: { relatedInspections: this.relatedInspections },
    };
    const dialogRef = this.dialog.open(RelatedInspectionsModalComponent, options);
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  webhookRetry() {
    this.disableRetry = true;
    this.historicalInspectionApi.resendInspection(this.inspection.id).subscribe(
      () => {
        this.toastr.success(
          'Inspection reenviada',
          '',
          {
            positionClass: 'toast-bottom-right',
          });
        setTimeout(() => {
          this.getInspection();
        }, 2000);
        setTimeout(() => {
          this.disableRetry = false;
        }, 30000);
      },
      (error) => {
        console.error(error);
        this.toastr.error(
          'Error al intentar reenviar la inspección', '',
          {
            positionClass: 'toast-bottom-right',
          });
      },
    );
  }
  parseAnalyzeResponse(picture) {
    const obj = [];
    if (picture.analyzeResponse && picture.analyzeResponse) {

      for (const element in picture.analyzeResponse) {
        if (element === 'badFraming') {
          obj.push({
            name: 'Encuadre',
            negativeName: 'Mal encuadre',
            value: Math.floor((1 - picture.analyzeResponse[element]) * 100),
            // class: (1 - picture.analyzeResponse[element]) < (1 - this.smartAnalyzerService.BAD_QUALITY_THRESHOLDS.minimumConfidenceBadFraming) ? `warning-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}` : `light-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}`,
            class: 'gray',
          });
        }
        if (element === 'badLighting') {
          obj.push({
            name: 'Iluminacion',
            negativeName: 'Mala Iluminación',
            value: Math.floor((1 - picture.analyzeResponse[element]) * 100),
            class: 1 - picture.analyzeResponse[element] < 1 - this.smartAnalyzerService.BAD_QUALITY_THRESHOLDS.minimumConfidenceBadLighting ? `warning-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}` : `light-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}`,
          });
        }
        if (element === 'pictureFromScreen') {
          obj.push({
            name: 'fotografía real',
            negativeName: 'fotografía a pantalla',
            value: Math.floor((1 - picture.analyzeResponse[element]) * 100),
            class: 1 - picture.analyzeResponse[element] < 1 - this.smartAnalyzerService.BAD_QUALITY_THRESHOLDS.minimumConfidencePictureFromScreen ? `warning-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}` : `light-${Math.floor((1 - picture.analyzeResponse[element]) * 100)}`,

          });
        }
        if (element === 'containsACar') {
          obj.push({
            name: 'Vehículo detectado',
            negativeName: 'vehículo no detectado',
            value: Math.floor((picture.analyzeResponse[element]) * 100),
            // class: picture.analyzeResponse[element] < this.smartAnalyzerService.BAD_QUALITY_THRESHOLDS.minimumConfidenceContainsAcar ? `warning-${Math.floor((picture.analyzeResponse[element]) * 100)}` : `light-${Math.floor((picture.analyzeResponse[element]) * 100)}`,
            class: 'gray',
          });
        }
        if (element === 'goodQuality') {
          obj.push({
            name: 'Calidad',
            negativeName: 'Mala calidad',
            value: Math.floor((picture.analyzeResponse[element]) * 100),
            class: picture.analyzeResponse[element] < this.smartAnalyzerService.BAD_QUALITY_THRESHOLDS.minimumConfidenceGoodQuality ? `warning-${Math.floor((picture.analyzeResponse[element]) * 100)}` : `light-${Math.floor((picture.analyzeResponse[element]) * 100)}`,

          });
        }
      }
    }
    return obj;

  }
  showAnalyzeResponse(picture) {
    picture.showAnalyzeResponse = !picture.showAnalyzeResponse;
  }
}
